import React from 'react'

export type SiderTheme = 'light' | 'dark'

const GlobalSelectLang = (globalThis as any)?.SelectLang as React.ComponentType<any> | undefined

export const SelectLang: React.FC = () => {
  if (!GlobalSelectLang) {
    return null
  }

  return (
    <GlobalSelectLang
      style={{
        padding: 4,
      }}
    />
  )
}
